export const paths = {
  PERSONAL_INFO: '/personuppgifter',
  TERMS: '',
  RULES: '/spelregler',
} as const;

export const CMSFolders = {
  TERMS: 'termsFolderId',
  TERMS_SERVICE: 'termsServiceFolderId',
  RULES: 'rulesFolderId',
  PERSON: 'personDataFolderId',
  COOKIES: 'cookiesFolderId',
  FAQ: 'faqCookiesFolderId',
  FAQ_PERSON: 'faqPersonDataFolderId',
} as const;
const { TERMS, TERMS_SERVICE, RULES, PERSON, COOKIES, FAQ, FAQ_PERSON } = CMSFolders;

export const folderTitles = {
  [TERMS]: 'Grundläggande kundvillkor',
  [TERMS_SERVICE]: 'Tjänstespecifika kundvillkor',
  [RULES]: 'Våra spel',
  [PERSON]: 'Dokument',
} as const;

export const CMSKinds = {
  DOCUMENT: 'doc',
  FAQ: 'faq',
} as const;

const { DOCUMENT, FAQ: FAQ_KIND } = CMSKinds;

export const CMSFolderKindMap = {
  [TERMS]: DOCUMENT,
  [TERMS_SERVICE]: DOCUMENT,
  [RULES]: DOCUMENT,
  [PERSON]: DOCUMENT,
  [COOKIES]: DOCUMENT,
  [FAQ]: DOCUMENT,
  [FAQ_PERSON]: FAQ_KIND,
} as const;

export type Folders = (typeof CMSFolders)[keyof typeof CMSFolders];
